import router from '@/routers'
import express from 'express'
import { cors_middleware, error_middleware, notFound } from './middlewares'

const app = express()
const port = 3030

app.use(express.json())
app.use(express.urlencoded({ extended: true }))
//middleware
app.use(cors_middleware)
app.use(error_middleware)
//routes
app.use(router)
//404
app.use(notFound)

app.listen(port, () => {
  console.log(`Server is running on http://localhost:${port}`)
})
11
